import {forceStart, forceDirection, rotateForce} from './force.js';
export const definitions = {
    rotateForce,
    forceStart,
    forceDirection
};
